import { render, staticRenderFns } from "./departmentModel.vue?vue&type=template&id=432c5c83"
import script from "./departmentModel.vue?vue&type=script&lang=js"
export * from "./departmentModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('432c5c83')) {
      api.createRecord('432c5c83', component.options)
    } else {
      api.reload('432c5c83', component.options)
    }
    module.hot.accept("./departmentModel.vue?vue&type=template&id=432c5c83", function () {
      api.rerender('432c5c83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/accountManage/departmentModel.vue"
export default component.exports